var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfblocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8968_28100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10938 2.87948C5.10938 2.39376 5.50313 2 5.98885 2H15.7511L21.1159 7.7166V20.9967C21.1159 21.4824 20.7221 21.8762 20.2364 21.8762H5.98885C5.50313 21.8762 5.10938 21.4824 5.10938 20.9967V2.87948Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1172 7.7163V12.9932L15.8908 7.7163L21.1172 7.7163Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.752 7.7166V2L21.1168 7.7166H15.752Z",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.10938,
    y: 18.3584,
    width: 11.2573,
    height: 1.93485,
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11.8496,
    width: 13.3681,
    height: 7.21171,
    rx: 0.351791,
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1308 17.7295V14.3523H6.33458C6.59732 14.3523 6.81499 14.4001 6.98759 14.4958C7.16019 14.5914 7.28936 14.7222 7.37511 14.8882C7.46086 15.0531 7.50374 15.2389 7.50374 15.4456C7.50374 15.6534 7.46031 15.8403 7.37346 16.0063C7.28771 16.1712 7.15799 16.302 6.98429 16.3987C6.8117 16.4944 6.59458 16.5422 6.33293 16.5422H5.50512V16.1102H6.28676C6.45276 16.1102 6.58743 16.0816 6.69077 16.0244C6.79411 15.9661 6.86996 15.887 6.91833 15.7869C6.9667 15.6869 6.99089 15.5731 6.99089 15.4456C6.99089 15.3181 6.9667 15.2048 6.91833 15.1059C6.86996 15.007 6.79356 14.9295 6.68912 14.8734C6.58578 14.8173 6.44946 14.7893 6.28016 14.7893H5.64034V17.7295H5.1308ZM9.19439 17.7295H8.10109V14.3523H9.22902C9.55993 14.3523 9.84411 14.4199 10.0816 14.5551C10.319 14.6892 10.501 14.8822 10.6274 15.1339C10.7549 15.3846 10.8187 15.6853 10.8187 16.0359C10.8187 16.3877 10.7544 16.6901 10.6257 16.9429C10.4982 17.1958 10.3135 17.3903 10.0717 17.5267C9.82982 17.6619 9.53739 17.7295 9.19439 17.7295ZM8.61064 17.2843H9.16636C9.42361 17.2843 9.63743 17.2359 9.80783 17.1391C9.97823 17.0413 10.1058 16.9 10.1904 16.7153C10.2751 16.5296 10.3174 16.3031 10.3174 16.0359C10.3174 15.771 10.2751 15.5462 10.1904 15.3615C10.1069 15.1768 9.98207 15.0366 9.81607 14.941C9.65007 14.8454 9.44394 14.7975 9.19769 14.7975H8.61064V17.2843ZM11.4523 17.7295V14.3523H13.5466V14.7909H11.9619V15.8199H13.3965V16.2569H11.9619V17.7295H11.4523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.668 15.0833V12.9583C15.668 12.2069 15.9665 11.4862 16.4978 10.9549C17.0292 10.4235 17.7499 10.125 18.5013 10.125C19.2527 10.125 19.9734 10.4235 20.5048 10.9549C21.0361 11.4862 21.3346 12.2069 21.3346 12.9583V15.0833",
    stroke: "#202E5F",
    strokeWidth: 1.275,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.543 15.083H23.4596V21.458C23.4596 21.8337 23.3104 22.1941 23.0447 22.4597C22.779 22.7254 22.4187 22.8747 22.043 22.8747H14.9596C14.5839 22.8747 14.2236 22.7254 13.9579 22.4597C13.6922 22.1941 13.543 21.8337 13.543 21.458V15.083Z",
    fill: "#202E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5039 18.5039L18.5039 19.5039L18.4954 18.5124L18.4954 18.5039L18.5039 18.5039Z",
    stroke: "#E2E5E7",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8968_28100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfblocked);
export default __webpack_public_path__ + "static/media/PDFBLOCKED.b77a98232a442a802198a81df8f9acbd.svg";
export { ForwardRef as ReactComponent };